<template>
  <div class="page">
    <!-- 标题 -->
    <div class="header">
      <h2>证券/银行类软件支持查询</h2>
      <p>输入软件名称进行模糊查询</p>
      <p>
        支持:
        <i class="el-icon-check" style="color: #67c23a; font-size: 18px; font-weight: bold"></i>
      </p>
    </div>

    <!-- 搜索 -->
    <el-card class="search-box" shadow="hover">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="18">
          <el-input v-model="keyword" clearable placeholder="请输入软件名称（支持模糊查询）" @keyup.enter.native="doSearch">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-col>

        <el-col :xs="24" :sm="6" class="btn">
          <el-button type="primary" style="width: 100%" @click="doSearch">
            查询
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- ================= 证券 ================= -->
    <el-card class="box" shadow="hover">
      <div class="title">📈 证券类软件</div>

      <el-table ref="stockTable" :data="showStockList" border stripe height="420" class="fixed">
        <el-table-column label="名称" min-width="110">
          <template slot-scope="{ row }">
            <el-tooltip :content="row.appName" :open-delay="1000">
              <span class="ellipsis">{{ row.appName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="windows客户端" width="130" align="center">
          <template slot-scope="{ row }">
            <i :class="row.window ? 'el-icon-check' : ''" :style="{
              color: row.window ? '#67C23A' : '#909399',
              fontSize: '18px',
              fontWeight: 'bold',
            }"></i>
          </template>
        </el-table-column>

        <el-table-column label="mac客户端" width="120" align="center">
          <template slot-scope="{ row }">
            <i :class="row.mac ? 'el-icon-check' : ''" :style="{
              color: row.mac ? '#67C23A' : '#909399',
              fontSize: '18px',
              fontWeight: 'bold',
            }"></i>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Web" width="60" align="center">
          <template slot-scope="{ row }">
            <i
              :class="row.web ? 'el-icon-check' : ''"
              :style="{
                color: row.web ? '#67C23A' : '#909399',
                fontSize: '18px',
                fontWeight: 'bold',
              }"
            ></i>
          </template>
        </el-table-column> -->
      </el-table>
    </el-card>

    <!-- ================= 银行 ================= -->
    <el-card class="box" shadow="hover">
      <div class="title">🏦 银行类软件</div>

      <el-table ref="bankTable" :data="showBankList" border stripe height="420" class="fixed">
        <!-- 名称 -->
        <el-table-column label="名称" min-width="110">
          <template slot-scope="{ row }">
            <el-tooltip :content="row.appName" :open-delay="1000">
              <span class="ellipsis">{{ row.appName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Win -->
        <el-table-column label="windows客户端" width="130" align="center">
          <template slot-scope="{ row }">
            <i :class="row.window ? 'el-icon-check' : ''" :style="{
              color: row.window ? '#67C23A' : '#909399',
              fontSize: '18px',
              fontWeight: 'bold',
            }"></i>
          </template>
        </el-table-column>

        <!-- Mac -->
        <el-table-column label="Mac客户端" width="120" align="center">
          <template slot-scope="{ row }">
            <i :class="row.mac ? 'el-icon-check' : ''" :style="{
              color: row.mac ? '#67C23A' : '#909399',
              fontSize: '18px',
              fontWeight: 'bold',
            }"></i>
          </template>
        </el-table-column>

        <!-- Web -->
        <el-table-column label="web网站" align="center">
          <el-table-column v-for="item in browserColumns" :key="item.key" :label="item.label" width="80" align="center">
            <template slot-scope="{ row }">
              <i :class="browserFlag(row, item.key)
                  ? 'el-icon-check'
                  : ''
                " :style="{
                  color: browserFlag(row, item.key)
                    ? '#67C23A'
                    : '#909399',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }"></i>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- ================= 全部不支持的银行 ================= -->
    <el-card v-if="showUnsupportedBankList.length > 0" class="box unsupported-box" shadow="hover">
      <div class="title">银行类软件（仅支持备忘：复制粘贴功能）</div>

      <el-table ref="unsupportedBankTable" :data="showUnsupportedBankList" border stripe height="420" class="fixed">
        <!-- 名称 -->
        <el-table-column label="名称" min-width="110">
          <template slot-scope="{ row }">
            <el-tooltip :content="row.appName" :open-delay="1000">
              <span class="ellipsis">{{ row.appName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>


      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getHotProblem } from "../../api/serve2";

export default {
  data() {
    return {
      keyword: "",

      pageSize: 10,

      browserColumns: [
        { label: "谷歌", key: "chrome" },
        { label: "微软", key: "edge" },
        { label: "360", key: "360" },
        { label: "火狐", key: "firefox" },
      ],

      // 分页
      stockPage: 1,
      bankPage: 1,
      unsupportedBankPage: 1,

      // 原始数据
      stockList: [],
      bankList: [],

      // 全部不支持的银行
      bankUnsupportedList: [],

      // 搜索后的数据
      stockFiltered: [],
      bankFiltered: [],
      unsupportedBankFiltered: [],

      // loading
      loadingStock: false,
      loadingBank: false,
      loadingUnsupportedBank: false,
    };
  },

  computed: {
    showStockList() {
      return this.stockFiltered.slice(
        0,
        this.stockPage * this.pageSize
      );
    },

    showBankList() {
      return this.bankFiltered.slice(
        0,
        this.bankPage * this.pageSize
      );
    },

    showUnsupportedBankList() {
      return this.unsupportedBankFiltered.slice(
        0,
        this.unsupportedBankPage * this.pageSize
      );
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    // =====================================================
    // 获取数据
    // =====================================================
    getList() {
      getHotProblem()
        .then((res) => {
          this.stockList = this.parse(res.data.stocks || []);

          const allBanks = this.parse(res.data.banks || []);

          // =================================================
          // 全部不支持的银行
          // Win、Mac、Web 全部为 false
          // =================================================
          this.bankUnsupportedList = allBanks.filter((item) => {
            return (
              !item.window &&
              !item.mac &&
              !item.web
            );
          });

          // =================================================
          // 正常银行列表
          // 排除 Win、Mac、Web 全部不支持的银行
          // =================================================
          this.bankList = allBanks.filter((item) => {
            return (
              item.window ||
              item.mac ||
              item.web
            );
          });

          // console.log("证券列表：", this.stockList);
          // console.log("正常银行列表：", this.bankList);
          // console.log(
          //   "全部不支持银行：",
          //   this.bankUnsupportedList
          // );

          // 初始化
          this.stockFiltered = this.stockList;
          this.bankFiltered = this.bankList;
          this.unsupportedBankFiltered =
            this.bankUnsupportedList;

          this.$nextTick(() => {
            this.bindScroll();
          });
        })
        .catch((error) => {
          console.error("获取数据失败：", error);
        });
    },

    // =====================================================
    // 数据转换
    // =====================================================
    parse(list) {
      return list.map((i) => {
        const [w, m, v] = i.strategy.split("_");

        return {
          appName: i.appName,

          window: w !== "-",

          mac: m !== "-",

          web: v !== "-",

          // 没有浏览器配置时，默认 {}
          browserSupport: i.browserSupport || {},
        };
      });
    },

    // =====================================================
    // 浏览器支持
    // =====================================================
    browserFlag(row, key) {
      // Web 不支持
      if (!row.web) {
        return false;
      }

      const browserSupport = row.browserSupport;

      // 没有浏览器限制
      // 默认全部支持
      if (
        !browserSupport ||
        typeof browserSupport !== "object" ||
        Object.keys(browserSupport).length === 0
      ) {
        return true;
      }

      // 有配置
      if (
        browserSupport[key] &&
        typeof browserSupport[key].flag !== "undefined"
      ) {
        return browserSupport[key].flag;
      }

      // 没有配置的浏览器默认支持
      return true;
    },

    // =====================================================
    // 搜索
    // =====================================================
    doSearch() {
  const key = this.keyword.trim().toLowerCase();

  const filter = (list) => {
    if (!key) {
      return list;
    }

    return list.filter((item) => {
      if (!item.appName) {
        return false;
      }

      const name = item.appName.toLowerCase();

      // =========================
      // ① 完整包含
      // =========================
      if (name.includes(key)) {
        return true;
      }

      // =========================
      // ② 字符逐个匹配
      //
      // 输入几个字，就要求全部匹配
      // 不要求连续
      // 不要求顺序
      // =========================
      const chars = [...new Set(key)];

      return chars.every((char) => {
        return name.includes(char);
      });
    });
  };

  // =========================
  // 证券：参与搜索
  // =========================
  this.stockFiltered = filter(this.stockList);

  // =========================
  // 正常银行：参与搜索
  // =========================
  this.bankFiltered = filter(this.bankList);

  // =========================
  // 仅支持备忘列表：
  // 永远显示全部，不参与搜索
  // =========================
  this.unsupportedBankFiltered = this.bankUnsupportedList;

  // 重置分页
  this.stockPage = 1;
  this.bankPage = 1;
  this.unsupportedBankPage = 1;

  this.$nextTick(() => {
    this.resetTableScroll("stockTable");
    this.resetTableScroll("bankTable");
    this.resetTableScroll("unsupportedBankTable");

    this.bindScroll();
  });
},

    // =====================================================
    // 重置滚动
    // =====================================================
    resetTableScroll(refName) {
      const table = this.$refs[refName];

      if (!table || !table.$el) {
        return;
      }

      const body = table.$el.querySelector(
        ".el-table__body-wrapper"
      );

      if (body) {
        body.scrollTop = 0;
      }
    },

    // =====================================================
    // 绑定滚动
    // =====================================================
    bindScroll() {
      this.removeScrollListeners();

      // 证券
      const stockTable = this.$refs.stockTable;

      if (stockTable && stockTable.$el) {
        const stockBody = stockTable.$el.querySelector(
          ".el-table__body-wrapper"
        );

        if (stockBody) {
          stockBody.addEventListener(
            "scroll",
            this.handleStockScroll
          );

          this._stockBody = stockBody;
        }
      }

      // 银行
      const bankTable = this.$refs.bankTable;

      if (bankTable && bankTable.$el) {
        const bankBody = bankTable.$el.querySelector(
          ".el-table__body-wrapper"
        );

        if (bankBody) {
          bankBody.addEventListener(
            "scroll",
            this.handleBankScroll
          );

          this._bankBody = bankBody;
        }
      }

      // 全部不支持银行
      const unsupportedBankTable =
        this.$refs.unsupportedBankTable;

      if (
        unsupportedBankTable &&
        unsupportedBankTable.$el
      ) {
        const unsupportedBody =
          unsupportedBankTable.$el.querySelector(
            ".el-table__body-wrapper"
          );

        if (unsupportedBody) {
          unsupportedBody.addEventListener(
            "scroll",
            this.handleUnsupportedBankScroll
          );

          this._unsupportedBankBody =
            unsupportedBody;
        }
      }
    },

    // =====================================================
    // 移除滚动监听
    // =====================================================
    removeScrollListeners() {
      if (this._stockBody) {
        this._stockBody.removeEventListener(
          "scroll",
          this.handleStockScroll
        );
        this._stockBody = null;
      }

      if (this._bankBody) {
        this._bankBody.removeEventListener(
          "scroll",
          this.handleBankScroll
        );
        this._bankBody = null;
      }

      if (this._unsupportedBankBody) {
        this._unsupportedBankBody.removeEventListener(
          "scroll",
          this.handleUnsupportedBankScroll
        );
        this._unsupportedBankBody = null;
      }
    },

    // =====================================================
    // 证券滚动
    // =====================================================
    handleStockScroll(e) {
      const el = e.target;

      if (this.loadingStock) {
        return;
      }

      const bottom =
        el.scrollTop + el.clientHeight >=
        el.scrollHeight - 10;

      if (bottom) {
        this.loadMoreStock();
      }
    },

    // =====================================================
    // 银行滚动
    // =====================================================
    handleBankScroll(e) {
      const el = e.target;

      if (this.loadingBank) {
        return;
      }

      const bottom =
        el.scrollTop + el.clientHeight >=
        el.scrollHeight - 10;

      if (bottom) {
        this.loadMoreBank();
      }
    },

    // =====================================================
    // 不支持银行滚动
    // =====================================================
    handleUnsupportedBankScroll(e) {
      const el = e.target;

      if (this.loadingUnsupportedBank) {
        return;
      }

      const bottom =
        el.scrollTop + el.clientHeight >=
        el.scrollHeight - 10;

      if (bottom) {
        this.loadMoreUnsupportedBank();
      }
    },

    // =====================================================
    // 加载更多证券
    // =====================================================
    loadMoreStock() {
      if (
        this.stockPage * this.pageSize >=
        this.stockFiltered.length
      ) {
        return;
      }

      this.loadingStock = true;

      setTimeout(() => {
        this.stockPage++;
        this.loadingStock = false;
      }, 150);
    },

    // =====================================================
    // 加载更多银行
    // =====================================================
    loadMoreBank() {
      if (
        this.bankPage * this.pageSize >=
        this.bankFiltered.length
      ) {
        return;
      }

      this.loadingBank = true;

      setTimeout(() => {
        this.bankPage++;
        this.loadingBank = false;
      }, 150);
    },

    // =====================================================
    // 加载更多不支持银行
    // =====================================================
    loadMoreUnsupportedBank() {
      if (
        this.unsupportedBankPage * this.pageSize >=
        this.unsupportedBankFiltered.length
      ) {
        return;
      }

      this.loadingUnsupportedBank = true;

      setTimeout(() => {
        this.unsupportedBankPage++;
        this.loadingUnsupportedBank = false;
      }, 150);
    },
  },

  beforeDestroy() {
    this.removeScrollListeners();
  },
};
</script>

<style scoped>
.page {
  max-width: 1200px;
  margin: 30px auto;
  padding: 10px;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h2 {
  margin: 0;
}

.header p {
  color: #909399;
}

.search-box {
  margin-bottom: 15px;
}

.box {
  margin-bottom: 20px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn {
  margin-top: 10px;
}

.unsupported-box {
  margin-top: 20px;
}

@media (min-width: 768px) {
  .btn {
    margin-top: 0;
  }
}
</style>